<template>
    <div class="jd-page--home">
        <div class="topBar">
            <jd-shbar></jd-shbar>
        </div>
        <k-hr size="88" />
        <!--<k-swipe :autoplay="3000" indicator-color="white" class="topSlider">
            <k-swipe-item><a href="https://mp.weixin.qq.com/s/Yv0Xjph5Y1swse6Bo6gvSQ"><img src="https://imgcdn-prd.pydp888.com/14/1/0/2877/f4915dbfa691516c7be64b4d057ecdc9.jpeg" alt="002期征集" class="topSlider__img"></a></k-swipe-item>
            <k-swipe-item><a href="https://bbs.xuanshang95.com/plugin.php?id=wei_shop"><img src="https://imgcdn-prd.pydp888.com/14/1/0/2574/b06a571d1eba760e061b646db8409661.jpeg" alt="商城" class="topSlider__img"></a></k-swipe-item>
            <k-swipe-item><a href="https://pai.xuanshang95.com/v1/Auction/index/sort/time.html"><img src="https://imgcdn-prd.pydp888.com/14/1/0/2580/000ed547fe1a115c877e6d7c8040cefa.jpeg" alt="轮播1" class="topSlider__img"></a></k-swipe-item>
            <k-swipe-item><a href="https://bbs.xuanshang95.com/plugin.php?id=wei_shop&amp;mod=product&amp;pid=69"><img src="https://imgcdn-prd.pydp888.com/14/1/0/3031/3624ac228b62e83ed169065819f1fa5f.jpeg" alt="开业大礼包" class="topSlider__img"></a></k-swipe-item>
        </k-swipe>-->
        <k-adv page-key="/biz/xs/jianding/home/" pos-key="topSlider"></k-adv>
        <home-slogin />
        <k-hr />
        <k-row class="bg-white">
            <k-col span="12" class="bd-right">
                <router-link to="/list" target="_blank">
                    <k-view-one title="找专家" des="专家把关 轻松收藏">
                        <template slot="left-icon"><span class="jd-icon jd-icon--zhuanjia k-mod-view--leftIcon"></span></template>
                    </k-view-one>
                </router-link>
            </k-col>
            <k-col span="12">
                <router-link to="/publish" target="_blank">
                    <k-view-one title="发布鉴定" des="藏品新老 一鉴解答">
                        <template slot="left-icon"><span class="jd-icon jd-icon--pub k-mod-view--leftIcon"></span></template>
                    </k-view-one>
                </router-link>
            </k-col>
        </k-row>
        <div id="topHeightBox"></div>
        <k-hr />
        <home-prd />
        <router-link v-if="pubShow" class="jd-home-publish-btn" to="/publish"><span>发布<br />鉴定</span></router-link>
        <jd-tabbar />
    </div>
</template>

<script>
    import {mapActions} from "vuex"
    import HomeSlogin from "./mod/slogin"
    import HomePrd from "./mod/home-prd"
    import {WZ} from "../../utils/wz.v2";
    export default {
        name: "index",
        data(){
            return {
                pubShow : false
            }
        },
        components : {
            HomeSlogin,
            HomePrd
        },
        methods:{
            ...mapActions("jianding", ["loadTabs"]),
            onDown(data){
                let el = document.querySelector("#topHeightBox");
                let divTop = el ? el.offsetTop : 0;
                if(data.scrollTop > divTop) {
                    this.pubShow = true
                }
                //console.log(data, divTop)
            },
            onUp(data){
                let el = document.querySelector("#topHeightBox");
                let divTop = el ? el.offsetTop : 0;
                if(data.scrollTop < divTop) {
                    this.pubShow = false
                }
            }
        },
        mounted() {
            this.loadTabs();
            WZ.onScrollDown(this.onDown);
            WZ.onScrollUp(this.onUp);
        },
        beforeDestory() {
            WZ.offScrollDown(this.onDown);
            WZ.offScrollUp(this.onUp);
        }
    }
</script>

<style scoped>

</style>